import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>,
)

// Tell the index.html boot guard that the app mounted successfully, so it never
// shows the fatal fallback or triggers a stale-bundle reload after this point.
if (typeof window !== 'undefined') {
  window.__APP_MOUNTED__ = true;
  try {
    sessionStorage.setItem('enkel_boot_ok', '1');
    sessionStorage.removeItem('enkel_boot_reload_ts');
  } catch { /* ignore */ }
}

if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    window.parent?.postMessage({ type: 'sandbox:beforeUpdate' }, '*');
  });
  import.meta.hot.on('vite:afterUpdate', () => {
    window.parent?.postMessage({ type: 'sandbox:afterUpdate' }, '*');
  });
}